import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { withJsonpSupport, withInterceptors } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';
// import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ToastsComponent } from './components/toasts/toasts.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { SideBarDesktopComponent } from './components/side-bar-desktop/side-bar-desktop.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { HeaderComponent } from './components/header/header.component';
import { SideBarMobileComponent } from './components/side-bar-mobile/side-bar-mobile.component';
import Lara from '@primeng/themes/lara';

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    ToastsComponent,
    AuthLayoutComponent,
    AppLayoutComponent,
    SideBarDesktopComponent,
    MenuItemComponent,
    HeaderComponent,
    SideBarMobileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(
      environment.firebase
    )),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    UserTrackingService,
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
    provideHttpClient(withJsonpSupport()),
    provideAnimationsAsync(),
    providePrimeNG({ 
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false
        }
      }
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
